export const Roles ={
    FACILITATOR : 1,
    ADMIN: 2
}